const WORK_MANAGEMENT_CLUSTER = {
    mini_site: {
        logo: {
            url: '/work-management',
            alt: 'monday.com work management',
            src: 'https://dapulse-res.cloudinary.com/image/upload/WM-oneliner-box.svg',
            mobileSrc: 'https://dapulse-res.cloudinary.com/image/upload/WM-oneliner-box.svg',
        },
        links: [
            {
                url: '/work-management',
                text: 'minisite.header.overview',
            },
            {
                url: '/w/work-management-for-enterprise',
                text: 'header.tabs.products.mondayEnterprise.newLayout.title',
            },
            {
                url: '/work-management/marketing',
                text: 'header.tabs.products.mondayMarketer.newLayout.title',
            },
            {
                url: '/work-management/pmo',
                text: 'header.tabs.products.mondayProjects.newLayout.title',
            },
            {
                url: '/work-management/pricing',
                text: 'minisite.header.pricing',
                isPricingPage: 'true',
            },
        ],
        unifiedDesktopLogo: {
            url: '/work-management',
            src: 'https://dapulse-res.cloudinary.com/image/upload/WM-oneliner-box.svg',
            alt: 'monday.com work management',
        },
    },
};

export { WORK_MANAGEMENT_CLUSTER };
